import { frequentlyBoughtTogether } from '@algolia/recommend-js'
import recommend from '@algolia/recommend'
import { algoliaAppId, algoliaApiKey, productSearchIndex } from '../variables'
import { isWithinDate } from '../utiils'

// eslint-disable-next-line no-undef
const { __, sprintf } = wp.i18n

const checkStringMatch = (originalString, checkString) => {
  if (!originalString) return false
  return checkString.startsWith(originalString)
}

const product = document.querySelector('.s-product')
if (product) {
  const recommendClient = recommend(algoliaAppId, algoliaApiKey)
  const currentObjectID = product.getAttribute('data-id')

  frequentlyBoughtTogether({
    container: '.s-product__recommend',
    recommendClient,
    indexName: productSearchIndex,
    objectIDs: [currentObjectID],
    fallbackComponent: () => {
      document.querySelector('.s-product-other__posts').style.display = ''
      return ''
    },
    headerComponent: () => {
      return ''
    },
    view: (renderOptions) => {
      const { html, items } = renderOptions

      return html`
        <div class="grid">
          ${items.map((item) => {
            const {
              iso8601,
              url,
              inPromotion,
              title,
              images,
              productTypes,
              labels,
              codeArticle,
            } = item

            const shouldHighlight = checkStringMatch(
              item._highlightResult.codeArticle?.matchedWords[0],
              codeArticle
            )

            let orientation = 'horizontal'
            if (
              images.height &&
              images.width &&
              images.height - images.width >= 100
            ) {
              orientation = 'vertical'
            }

            return html` <article
              class="feed-product g-col-12 g-col-md-6 g-col-lg-4 g-col-xl-3 ${images.base
                ? ' has-post-thumbnail'
                : ''}"
            >
              <a href="${url}" class="feed-product__wrapper">
                <div class="feed-product__top">
                  ${isWithinDate(iso8601)
                    ? html`
                        <span class="icon-badge icon-badge--primary">
                          <span class="vn-a-icon"
                            ><i class="vn-icons-drap-star"></i
                          ></span>
                          <span class="vn-a-content">${__('New!', 'vn')}</span>
                        </span>
                      `
                    : ''}
                  ${inPromotion
                    ? html`
                        <span class="icon-badge icon-badge--secondary">
                          <span class="vn-a-icon"
                            ><i class="vn-icons-drap-info"></i
                          ></span>
                          <span class="vn-a-content"
                            >${__('Promotion!', 'vn')}</span
                          >
                        </span>
                      `
                    : ''}
                </div>

                <div class="feed-product__middle">
                  ${images.base
                    ? html`<img
                        src="${images.base}"
                        alt="${title}"
                        class="feed-product__thumbnail ${orientation}"
                      />`
                    : ''}
                </div>

                <div class="feed-product__bottom">
                  ${productTypes.length
                    ? html`
                        <div class="feed-product__types">
                          ${productTypes.map((productType) => {
                            let res
                            productType.images && productType.images.thumbnail
                              ? (res = html`<span
                                  class="feed-product__with-image-icon"
                                  ><span class="vn-a-icon"
                                    ><img
                                      decoding="async"
                                      src="${productType.images.thumbnail}"
                                      class="inject-this feed-product__icon"
                                      alt="${productType.name}" /></span
                                  >${productType.name}</span
                                >`)
                              : (res = html`<span>${productType.name}</span>`)
                            return res
                          })}
                        </div>
                      `
                    : ''}

                  <span class="feed-product__title"
                    >${item._highlightResult.title.value}</span
                  >

                  <div class="feed-product__footer">
                    <span class="feed-product__ref"
                      >${sprintf(
                        __('Ref: %s', 'vn'),
                        shouldHighlight
                          ? item._highlightResult.codeArticle.value
                          : codeArticle
                      )}</span
                    >

                    ${labels.length
                      ? html`
                          <div class="feed-product__label-images">
                            ${labels.map((label) => {
                              return label.image.url
                                ? html`<img
                                    src="${label.image.url}"
                                    alt="${title}"
                                  />`
                                : ''
                            })}
                          </div>
                        `
                      : ''}
                  </div>
                </div>
              </a>
            </article>`
          })}
        </div>
      `
    },
  })
}
